import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import buttonStyles from './91274a1d9a9d7c4d26f941102723fa0908c061d2e048fd7382d0966f9927d51a.cfe-internal.js';
import { useInputGroupContext } from '../InputGroup/fc923f7df98798752b55075d988c99381886b50e072df75d1b96be0b82f76494.cfe-internal.js';

var _excluded = ["children", "kind", "disabled", "small", "full", "className", "type", "onClick", "onKeyDown", "aria-disabled"];
var Button = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$kind = _ref.kind,
    kind = _ref$kind === void 0 ? 'default' : _ref$kind,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? false : _ref$full,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    ariaDisabled = _ref['aria-disabled'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var inputGroupContext = useInputGroupContext();
  var classes = classNames(className, buttonStyles.btn, inputGroupContext.className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, buttonStyles[kind], kind), buttonStyles.disabled, disabled), buttonStyles.small, inputGroupContext.applySmall(small)), buttonStyles.full, inputGroupContext.applyFull(full)));
  var clickHandler = function clickHandler(e) {
    if (disabled) {
      // stops form submission for type="submit"
      return e.preventDefault();
    }
    onClick === null || onClick === void 0 || onClick(e);
  };
  var keyDownHandler = disabled ? undefined : onKeyDown;
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    "aria-disabled": ariaDisabled !== null && ariaDisabled !== void 0 ? ariaDisabled : disabled,
    type: type,
    className: classes,
    ref: ref,
    onClick: clickHandler,
    onKeyDown: keyDownHandler
  }), children);
});

export { Button };
